import { formatCustomerDateTime } from "../Utils/autopilotDateTime";
import { workflowStepParts } from "./AutopilotSetup/PackageWorkflowCards";
import "./ActiveAutopilotBanner.css";

const ACTIVE_AUTOPILOT_IMAGE = "https://ucarecdn.com/50c649f8-64a8-480f-9136-985b0772920e/noroot.png";

// Same text as before; the date and the "בשעה HH:MM" part are separate
// spans so a narrow layout can wrap between them (see design-soft.css).
const DateTimeParts = ({ text }) => {
  const [datePart, timePart] = String(text).split(" בשעה ");
  if (!timePart) return text;
  return (
    <>
      <span className="active-autopilot__date-part">{datePart}</span>{" "}
      <span className="active-autopilot__time-part">בשעה {timePart}</span>
    </>
  );
};

const stepStatus = (step = {}) => String(step.executionStatus || step.status || "pending").toLowerCase();

const ActiveAutopilotBanner = ({ steps = [] }) => {
  const validSteps = Array.isArray(steps) ? steps : [];
  const completedSteps = validSteps.filter((step) => stepStatus(step) === "completed").length;
  const pausedSteps = validSteps.filter((step) => stepStatus(step) === "paused").length;
  const completionPercent = validSteps.length > 0
    ? Math.round((completedSteps / validSteps.length) * 100)
    : 0;
  const nextStep = validSteps
    .filter((step) => !["completed", "paused", "failed", "requiresattention"].includes(stepStatus(step)))
    .filter((step) => Number.isFinite(new Date(step.scheduledAt).getTime()) && new Date(step.scheduledAt).getTime() > Date.now())
    .sort((left, right) => new Date(left.scheduledAt).getTime() - new Date(right.scheduledAt).getTime())[0];
  const nextStepCopy = nextStep ? workflowStepParts(nextStep) : null;
  const hasPausedStepsWithoutNext = !nextStep && pausedSteps > 0;
  const emptyStateTitle = hasPausedStepsWithoutNext ? "אין שלב פעיל מתוזמן" : "אין שלב נוסף כרגע";
  const emptyStateDetail = hasPausedStepsWithoutNext
    ? (pausedSteps === 1 ? "שלב אחד מושהה" : `${pausedSteps} שלבים מושהים`)
    : "כל השלבים המתוזמנים הושלמו";
  const badgePosition = `clamp(27px, ${completionPercent}%, calc(100% - 27px))`;

  return (
    <section className="active-autopilot" role="status" dir="rtl">
      <div className="active-autopilot__card">
        <header className="active-autopilot__card-title">
          <h2>קצב התקדמות</h2>
        </header>

        <div className="active-autopilot__progress-area">
          <div className="active-autopilot__progress-scale">
            <span className="active-autopilot__scale-min">0</span>
            <div className="active-autopilot__progress-wrap">
              <strong className="active-autopilot__percent" style={{ left: badgePosition }}>{completionPercent}%</strong>
              <div className="active-autopilot__track" role="progressbar" aria-label={`התקדמות ${completionPercent}%`} aria-valuemin="0" aria-valuemax="100" aria-valuenow={completionPercent}>
                <span className="active-autopilot__fill" style={{ width: `${completionPercent}%` }} />
              </div>
            </div>
            <span className="active-autopilot__scale-max">100</span>
          </div>
        </div>

        <div className={`active-autopilot__next-card${nextStep ? "" : " is-empty"}`}>
          <div className="active-autopilot__next-copy">
            <span>{hasPausedStepsWithoutNext ? "מצב התוכנית:" : "ההודעה הבאה:"}</span>
            <strong>{nextStepCopy?.action || emptyStateTitle}</strong>
            {nextStepCopy?.detail && <small>{nextStepCopy.detail}</small>}
          </div>
          <div className="active-autopilot__next-time">
            <time dateTime={nextStep?.scheduledAt}>{nextStep ? <DateTimeParts text={formatCustomerDateTime(nextStep.scheduledAt)} /> : emptyStateDetail}</time>
          </div>
          <img className="active-autopilot__robot" src={ACTIVE_AUTOPILOT_IMAGE} alt="עוזר הטייס האוטומטי" />
        </div>
      </div>
    </section>
  );
};

export default ActiveAutopilotBanner;
